export default "__VITE_ASSET__D04FZIXq__ 1300w";